import React from "react";
import { motion } from "framer-motion";
import { ChevronsRight } from "lucide-react";
import about_bg from "../../assets/images/event.png"
import { Link } from "react-router-dom";
const EventsBanner1 = () => {
    return (
        <section className="relative w-full min-h-[500px] md:min-h-[550px] text-slate-900 overflow-hidden flex items-end pt-36 pb-16 md:pt-44">
            <div
                className="pointer-events-none absolute inset-0 opacity-20 z-0"
                style={{
                    background:
                        "linear-gradient(135deg, #62d4f7 0%, #5dc9f0 40%, #3579be 60%, #3579be 100%)",
                }}
            />
            <div className="pointer-events-none absolute inset-0 z-0">
                <img
                    src={about_bg}
                    alt=""
                    className="w-full h-full object-cover object-center brightness-105"
                />
            </div>
            <div className="mx-auto max-w-7xl px-6 lg:px-12 py-10 relative z-10 w-full">
                <div className="max-w-4xl mx-auto">
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.6,
                            ease: [0.16, 1, 0.3, 1],
                        }}
                        className="text-balance text-4xl sm:text-6xl md:text-7xl font-semibold text-center tracking-tight text-white">
                        Hear from our experts at events all over the world
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.55,
                            delay: 0.12,
                            ease: "easeOut",
                        }}
                        className="mt-6 text-base text-slate-100 flex flex-row gap-1 items-center justify-center leading-relaxed" >
                        <Link to="/">Home</Link>
                        <ChevronsRight size={20} />
                        Events
                    </motion.p>
                </div>
            </div>
        </section>
    );
};

export default EventsBanner1;
